import React from 'react';

import SourceIcon from '@mui/icons-material/Source';
import { Box, Typography, Stack, Paper, IconButton } from '@mui/material';

import { Button } from 'shared';
import { formatTransaction, formatInventory } from 'components/Inventory/utils/aiMatchingHelpers';

const CompletedMatchCard = ({
    cardData,
    index,
    classes,
    handleEmailSourceClick,
    skipMatch,
    handleMatchClick,
    excludeLoading,
    handleExcludeClick,
    doNotShowAgainLoading,
    handleDoNotShowAgainClick,
}) => {
    if (!cardData) return null;

    const transactionObj = cardData.transaction || {
        id: cardData.transaction_id,
        amount: cardData.amount,
        date: cardData.date,
        description: cardData.description,
        vendor: cardData.description,
        card_last4: cardData.card_last4,
        bank_name: cardData.bank_name,
    };

    const transactionStr = formatTransaction(transactionObj);
    const inventoryStr = formatInventory(cardData.matched_inventory);

    return (
        <Paper key={`complete-match-${index}`} elevation={3} sx={classes.completeCard}>
            <Box>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                    <Typography variant="subtitle1" fontWeight="bold">
                        Transactions
                    </Typography>
                    {(() => {
                        const emails = Array.isArray(cardData?.email_data)
                            ? cardData.email_data
                            : cardData?.email_data
                                ? [cardData.email_data]
                                : [];
                        return emails.length > 0 && (
                            <IconButton onClick={() => handleEmailSourceClick(cardData)} p={0}>
                                <SourceIcon fontSize="small" />
                            </IconButton>
                        );
                    })()}
                </Box>
                <Typography variant="body1" marginBottom={2}>
                    {transactionStr}
                </Typography>

                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mt={3}
                    mb={1}
                >
                    <Typography variant="subtitle1" fontWeight="bold">
                        Inventories
                    </Typography>
                </Box>

                <Box display="flex" alignItems="center" gap={1} mb={2}>
                    <Typography variant="body1" sx={{ flexGrow: 1 }}>
                        {inventoryStr}
                    </Typography>
                </Box>

                <Typography variant="body2" sx={classes.textOnereason}>
                    {cardData.reasoning}
                </Typography>

                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="space-between"
                    mt={3}
                    alignItems="center"
                    width="100%"
                >
                    <Box>
                        <Button
                            sx={classes.cancelButton}
                            text="Don't Show Again"
                            loading={doNotShowAgainLoading}
                            onClick={() => {
                                handleDoNotShowAgainClick(cardData, 'userInputCard');
                            }}
                        />
                    </Box>

                    <Box display="flex" gap={2}>
                        <Button
                            sx={classes.cancelButton}
                            text="Exclude"
                            loading={excludeLoading}
                            onClick={() => {
                                handleExcludeClick(cardData, 'matchCard');
                            }}
                        />

                        <Button
                            sx={classes.cancelButton}
                            text="Skip"
                            onClick={() => {
                                skipMatch(cardData, 'matchCard');
                            }}
                        />

                        <Button
                            text="Match"
                            variant="contained"
                            onClick={() => handleMatchClick({}, cardData, 'matchCard')}
                        ></Button>
                    </Box>
                </Stack>
            </Box>
        </Paper>
    );
};

export default CompletedMatchCard;
